// extracted by mini-css-extract-plugin
module.exports = {"code":"Code_code__Sl3lc","light":"Code_light__2mLdx","dark":"Code_dark__1-zqu","inline":"Code_inline__2CWnH"};